import React, { Component } from 'react'
import { Pagination, Row, Button, Spin, Modal, Col } from 'antd'
import { app, api, config } from "../../../app"

class TeamEquipments extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            teamno: props.match.params.teamno,
            teamname: "正在加载 ... "
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { teamno } = this.state,
            params = {
                page,
                teamno,
                request: "team",
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total, teamname } = await app.post(api.TeamEquipList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(total || 0) })
        }
    }

    handleToDetail = (info) => {
        Modal.info({
            title: '装备详情',
            width: '60vw',
            centered: true,
            content: (
                <div style={{ height: '60vh', overflow: 'auto' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备名称</Col>
                        <Col span={14} offset={1}>{info.equip_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备来源</Col>
                        <Col span={14} offset={1}>{info.equip_source}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备数量</Col>
                        <Col span={14} offset={1}>{info.equip_num}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>报废数量</Col>
                        <Col span={14} offset={1}>{info.equip_scrapped_num}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>添加时间</Col>
                        <Col span={14} offset={1}>{info.submit_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>上次检修日期</Col>
                        <Col span={14} offset={1}>{info.equip_overhaul_time || '-'}</Col>
                    </Row>
                    <div>
                        <div>装备图片</div>
                        <div style={{ height: 200, marginTop: 10 }}>
                            <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                 src={config.imgUrl + info.equip_img} alt=""/>
                        </div>
                    </div>
                </div>
            ),
        })
    }

    render () {
        let { data_loading, teamname, dataList, total, page } = this.state
        return (
            <div className="equipments-page">
                <Row className="equipments-title" type="flex" justify="space-between">
                    <span>队伍装备（{teamname}）</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="mp-content">
                    <Row className="no-data" type="flex" justify="center" align="middle" hidden={!data_loading}><Spin/></Row>
                    <div className="mp-list" hidden={data_loading}>
                        {
                            dataList.map((item, i) => {
                                return (
                                    <div className="dl-img-item" key={i} onClick={() => this.handleToDetail(item)}>
                                        <div className="dii-img"><img src={config.imgUrl + item.equip_img}/></div>
                                        <div className="dii-name">
                                            <div>{item.equip_name}</div>
                                            <div>{item.equip_num}件</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
            </div>
        )
    }
}

export default TeamEquipments



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamEquipments.jsx